<form #normalizationForm="ngForm" autocomplete="off" class="normalization-rules-dialog">

  <mat-form-field class="normalization-name">
    <mat-label>Name</mat-label>
    <input [(ngModel)]="group.groupName" matInput name="name" required maxlength="255">
  </mat-form-field>

  <div class="normalization-rules">
    <div class="rule-and-replace">
      <div class="normalization-rule" *ngFor="let rule of group.normalizationAttrs; let index = index; let first = first; let last = last">

        <mat-form-field class="regExp">
          <mat-label>Regular expression</mat-label>
          <input [(ngModel)]="rule.regEx" matInput [name]="'regEx-' + index" maxlength="255">
        </mat-form-field>

        <mat-form-field class="replace-by">
          <mat-label>Replace By</mat-label>
          <input [(ngModel)]="rule.replacement" matInput [name]="'replacement-' + index" maxlength="255">
        </mat-form-field>

        <mat-form-field class="description">
          <mat-label>Description</mat-label>
          <input [(ngModel)]="rule.description" matInput [name]="'description-' + index" maxlength="255">
        </mat-form-field>

        <div class="intermediate-result-container">
          <span title="{{rule.intermediateResult}}">{{rule.intermediateResult}}</span>
        </div>

        <div class="rule-actions" *ngIf="!isUnauthorized">
          <div class="remove-rule">
            <i class="fa fa-arrow-up" (click)="moveUpRule(index)" [ngClass]="{'fa-disabled': first}"></i>
          </div>

          <div class="remove-rule">
            <i class="fa fa-arrow-down" (click)="moveDownRule(index)" [ngClass]="{'fa-disabled': last}"></i>
          </div>

          <div class="remove-rule">
            <i class="fa fa-times" (click)="removeRule(index)"></i>
          </div>
        </div>

      </div>
    </div>

    <div class="actions">
      <button (click)="addRule()" cy-data="add" mat-icon-button matTooltip="Add" *ngIf="!isUnauthorized">
        <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
      </button>
    </div>
  </div>

  <ac-line-separator></ac-line-separator>

  <div class="test-normalization">

    <mat-form-field class="test-string-container">
      <mat-label>Test string</mat-label>
      <input [(ngModel)]="testString" matInput name="testString">
    </mat-form-field>

    <ac-button class="test-normalization-button"
            type="button" (click)="testNormalizationGroup()" [ngDisabled]="!testString || group.normalizationAttrs.length === 0">Test</ac-button>

    <mat-form-field class="simulation-result-container">
      <mat-label>Simulation Result</mat-label>
      <input [(ngModel)]="simulationResult" matInput name="simulation-result"  title="{{simulationResult}}" disabled>
    </mat-form-field>

  </div>

</form>
